module.exports = __webpack_public_path__ + "img/4.da711685.jpg";